<ion-card 
                    style="border-radius: 0.5em;height: 100%;"
                   >
                   
                   <ion-grid class="ion-no-padding" style="color: black;">
                    <ion-row  >
                      <ion-col style="padding: 0.4em;">
                        <ion-label style="color: var(--Black-shade, #161616);
                        font-feature-settings: 'clig' off, 'liga' off;
                        
                        /* heading cards */
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 16px; /* 133.333% */
                        letter-spacing: 1.5px;
                        text-transform: uppercase;"> {{deposit['type']['label']}}</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col class="ion-padding">
                        <ion-label>{{deposit['type']['assignable_text']}}</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col>
                        <ion-item lines="none">
                        <ion-label class="ion-text-wrap">
                          {{deposit['updated_at'] | date:dataService.settings['system']['datemask']}}

                        </ion-label>
                        <ion-label style="text-align: right;" class="ion-text-wrap">
                          {{deposit['amount'] | currency}}
                        </ion-label>
                      </ion-item>
                      </ion-col>
                    </ion-row>
                   </ion-grid>
                  
                     </ion-card>